import { GradientFillValue } from '@company-box/models';
import { hexToCmyk } from './color-conversion';

// The host app's secondary brand color (--secondary-highlight, set on html.cb/html.fedex by
// styles-cb.scss/styles-fedex.scss), so fill defaults follow whichever app the shared libraries run
// in. Falls back to black if the variable is missing.
export function appSecondaryColor(): string {
  const secondary = getComputedStyle(document.documentElement).getPropertyValue('--secondary-highlight').trim();
  return /^#[0-9a-f]{6}$/i.test(secondary) ? secondary : '#000000';
}

// The starting gradient for the Fill flyout and the gradient pickers: white to the app's secondary color.
export function defaultGradientFill(): GradientFillValue {
  const to = appSecondaryColor();
  return {
    type: 'linear',
    from: { hex: '#ffffff', cmyk: hexToCmyk('#ffffff') },
    to: { hex: to, cmyk: hexToCmyk(to) },
    angle: 0,
  };
}

// CSS preview for the Gradient/Linear/Radial tiles. Matches svgGradient()'s geometry at its defaults:
// angle 0 runs left to right, and a radius of 0.5 reaches each edge of the tile - an ellipse in the
// 4:3 preview, the same way a gradient stretches on a non-square panel.
export function gradientPreviewCss(type: GradientFillValue['type'], from: string, to: string): string {
  return type === 'linear' ? `linear-gradient(90deg, ${from}, ${to})` : `radial-gradient(closest-side, ${from}, ${to})`;
}
